import { BrandMetadata } from 'common/brandMetadata/types';
import { BrandName } from 'common/environment/types';

export const BRAND_METADATA_BY_BRAND_NAME: Record<BrandName, BrandMetadata> = {
  vertex: {
    displayName: 'Vertex',
  },
  blitz: {
    displayName: 'Blitz',
  },
  stackd: {
    displayName: "ArCa Perps",
  },
};
